const StandStill = () => {
  return (
    <section
      id="stand-still"
      className="relative py-28 px-6 overflow-hidden"
    >
      {/* Background image */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/94344fc083b5e40567017be4d0e78be0.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-black/78" />
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, rgba(212,168,66,0.08) 0%, transparent 65%)' }}
      />
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.4), transparent)' }}
      />
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.4), transparent)' }}
      />

      <div className="max-w-2xl mx-auto relative z-10 text-center">
        <div
          className="inline-block mb-6 px-4 py-1 rounded-full text-xs font-semibold tracking-widest uppercase"
          style={{ background: 'rgba(212,168,66,0.1)', border: '1px solid rgba(212,168,66,0.3)', color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
        >
          A Call to Return
        </div>

        <h2
          className="text-3xl md:text-5xl font-black uppercase mb-8 leading-tight"
          style={{ fontFamily: "'Glacial Indifference', sans-serif", color: '#FFFFFF', textShadow: '0 0 40px rgba(212,168,66,0.3)' }}
        >
          Stand Still <br />
          <span style={{ color: '#D4A842' }}>and Know</span>
        </h2>

        <div
          className="rounded-2xl p-8 md:p-10 mb-8 text-left"
          style={{
            background: 'linear-gradient(135deg, rgba(212,168,66,0.07) 0%, rgba(0,0,0,0.4) 100%)',
            border: '1px solid rgba(212,168,66,0.2)',
            backdropFilter: 'blur(4px)',
          }}
        >
          <p className="text-base md:text-lg text-gray-200 leading-loose mb-4" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            In a world full of <strong className="text-white">noise</strong>, <strong className="text-white">pressure</strong>,{' '}
            <strong className="text-white">confusion</strong>, and <strong className="text-white">distraction</strong>,{' '}
            God is still calling a generation to stand still and know that He is God.
          </p>
          <p className="text-base text-gray-300 leading-loose" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            This conference is a call back to His{' '}
            <span style={{ color: '#D4A842' }}>presence</span>,{' '}
            His <span style={{ color: '#D4A842' }}>voice</span>,{' '}
            His <span style={{ color: '#D4A842' }}>power</span>, and{' '}
            His <span style={{ color: '#D4A842' }}>purpose</span>.
          </p>
        </div>

        {/* Big quote */}
        <div
          className="rounded-2xl py-8 px-6 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(212,168,66,0.12) 0%, rgba(212,168,66,0.04) 100%)',
            border: '1.5px solid rgba(212,168,66,0.4)',
          }}
        >
          <i className="ri-double-quotes-l text-4xl mb-3 block" style={{ color: 'rgba(212,168,66,0.35)' }} />
          <p
            className="text-2xl md:text-3xl font-bold italic leading-snug"
            style={{ fontFamily: 'Playfair Display, serif', color: '#FFFFFF' }}
          >
            &quot;Be still, and know<br />that I am God.&quot;
          </p>
          <p className="mt-4 text-sm font-semibold tracking-widest uppercase" style={{ color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}>
            Psalm 46:10
          </p>
        </div>
      </div>
    </section>
  );
};

export default StandStill;
